module.exports = __webpack_public_path__ + "img/logo-bold-beta.b97fa73d.jpg";